<template>
  <div class="fccPublicacoesTVisualizacao">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            addFilter
            :items="listagemTipo"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          ></fccTable>
        </div>
      </div>
      <fccModal
        centered
        idModal="addFieldModal"
        size="lg"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <form
          autocomplete="off"
          @submit.prevent="
            criarTipo.idtipovisualizacao === 0
              ? adicionarTipoVisualizacao()
              : editandoTipoVisualizacao()
          "
        >
          <div class="row">
            <div class="col-sm-6">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.codigounico"
                >Código</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.dstipovisualizacao"
                >Tipo de Visualização</fccInput
              >
              <input type="hidden" v-model="criarTipo.ordem" />
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.dsdescricaotecnica"
                >Descrição Técnica</fccInput
              >
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-5 text-right">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.iconecombo"
                >Ícone Combo</fccInput
              >
            </div>
            <div class="col-sm-1 innerPage">
              <font-awesome-icon
                :icon="criarTipo.iconecombo"
                size="lg"
                v-if="criarTipo.iconecombo"
              />
            </div>
            <div class="col-sm-5 text-right">
              <fccInput extraClasses="inputLabel" required v-model="criarTipo.iconecampo"
                >Ícone Campo</fccInput
              >
            </div>
            <div class="col-sm-1 innerPage">
              <font-awesome-icon
                :icon="criarTipo.iconecampo"
                size="lg"
                v-if="criarTipo.iconecampo"
              />
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-6">
              <toggle-button v-model="criarTipo.ativo" :sync="true" /> Ativo
            </div>
          </div>
          <div class="row innerPage">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">{{
                labelsSystem.salvar
              }}</fccButton>
            </div>
          </div>
        </form>
      </fccModal>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Padrões de Visualização',
      titlePDF: 'Lista de Tipos de Parâmetros',
      titleModal: '',
      fields: [
        { key: 'idtipovisualizacao', label: 'Id', sortable: false },
        { key: 'codigounico', label: 'Código', sortable: false },
        { key: 'dstipovisualizacao', label: 'Tipo', sortable: true },
        { key: 'dsdescricaotecnica', label: 'Descrição', sortable: true },
        { key: 'actions', label: '' }
      ],
      itemPorPage: '100',
      listagemTipo: [],
      criarTipo: {},
      actions: [
        {
          button: true,
          funcaoButton: 'camposField',
          icon: 'wrench',
          tooltip: 'Campos',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  methods: {
    listarTipoVisualizacao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoForm + 'TVisualizacao/ListarTipoVisualizacao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemTipo = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    deleteField: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.dstipovisualizacao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlGestaoForm +
                'TVisualizacao/ExcluirTipoVisualizacao/' +
                item.idtipovisualizacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarTipoVisualizacao()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    camposField: function (action, item) {
      this.$router.push({ path: '/publicacoes/tipovisualizacao/' + item.idtipovisualizacao })
    },
    editField: function (actions, items) {
      this.criarTipo = items
      this.titleModal = 'Editar Tipo de Visualização'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    addField: function () {
      this.criarTipo = {}
      this.criarTipo.idtipovisualizacao = 0
      this.criarTipo.ordem = 0
      this.titleModal = 'Adicionar Tipo de Visualização'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editandoTipoVisualizacao: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlGestaoForm + 'TVisualizacao/AlterandoTipoVisualizacao',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoVisualizacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    adicionarTipoVisualizacao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlGestaoForm + 'TVisualizacao/AdicionarTipoVisualizacao',
          this.criarTipo,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarTipoVisualizacao()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlGestaoForm = store.state.baseUrlGestaoForm
    this.listarTipoVisualizacao()
  }
}
</script>
